export const getEnumKeys = (myEnum: never) => {
  return Object.keys(myEnum).map(key => myEnum[key])
}
